import React, {useEffect} from 'react';

import FormControl from '@mui/joy/FormControl';
import Grid from '@mui/joy/Grid';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';

// Icon
import IcoPercent from '@mui/icons-material/Percent';


export default function Sleep(props) {
	const [percent, setPercent] = React.useState(0);
	
	useEffect(() => {
		props.handleClick(props.activeCard && percent > 0, percent);			
	}, [props.activeCard]);
		

	function handleChange(e) {
		setPercent(e.target.value);
		props.handleClick(props.activeCard && (e.target.value > 0), e.target.value);	
	}

	return (
	    <FormControl>
	    	<Grid container xs={4}>
	            <FormLabel>My stop</FormLabel>
				<Input type="number" variant="solid" autoFocus disabled={!props.activeCard} size="lg" startDecorator={<IcoPercent />} onChange={(e) => {handleChange(e);}} onWheel={(e) => e.target.blur()}/>
			</Grid>
		</FormControl>
	)
}